import { vueAppWithPinia } from "../Common/vueApp";
import FederationDashboardApp from "./FederationDashboardApp.vue";

export default vueAppWithPinia(FederationDashboardApp);
